import intersection from "lodash.intersection";
import uniq from "lodash.uniq";
import { getUserLocales } from "get-user-locale";
export default function getClientLocale(_ref) {
  var defaultLocale = _ref.defaultLocale,
      locales = _ref.locales;

  var userLocales = normalizeLocales(getUserLocales());
  var wantedLocales = normalizeLocales(locales);
  var matchedLocales = intersection(userLocales, wantedLocales);
  return matchedLocales.length ? matchedLocales[0].replace("-", "_") //lokalise format
  : defaultLocale;
}
var regionLocaleRegexp = /(\w{2})(?:[-_]\w{2})/;
function normalizeLocales(locales) {
  var normalized = [];
  locales.forEach(function (locale) {
    normalized.push(locale.replace("_", "-")); //standard format
    var regionLocale = regionLocaleRegexp.exec(locale);
    if (regionLocale) {
      normalized.push(regionLocale[1]);
    }
  });
  return uniq(normalized);
}